import { Box, Grid, Heading } from '@chakra-ui/react';
import { RecipeListResponse } from '@diamond/shared/types';
import { trackEvent } from '@diamond/shared/utils';
import { TRACKING_EVENTS, TRACKING_PAGES } from '@diamond/sol-buyer/constant';

import { RecipeCard } from './RecipeCard';

type RecipeListProps = {
  title?: string;
  data: RecipeListResponse['data'];
};

export function RecipeList({ title, data }: RecipeListProps) {
  return (
    <Box>
      {title ? (
        <Heading
          mb={4}
          fontSize={{ base: 'lg', md: 'xl' }}
          fontWeight="semibold"
        >
          {title}
        </Heading>
      ) : null}
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(2, minmax(0, 1fr))' }}
        gap={{ base: 2, lg: 6 }}
      >
        {data.map((recipe) => (
          <RecipeCard
            key={recipe.id}
            recipe={recipe}
            mb="unset"
            handleTrackEvent={(recipe) => {
              trackEvent(TRACKING_EVENTS.SELECT_RECIPE, {
                id: recipe.id,
                name: recipe.title,
                brand: recipe.brands.toString(),
                section_name: TRACKING_PAGES.RECIPE,
              });
            }}
          />
        ))}
      </Grid>
    </Box>
  );
}
